import { recordWebVitals } from './services/api';

const SEND_AFTER_MS = 10000;

/** One sample per page load: Core Web Vitals plus context, sent when the page is hidden or after 10 s. */
const reportWebVitals = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const sample = {};
    let sent = false;
    const send = () => {
        if (sent || !('fcp' in sample || 'ttfb' in sample)) return;
        sent = true;
        const connection = navigator.connection || {};
        recordWebVitals({
            ...sample,
            path: window.location.pathname,
            conn: connection.effectiveType || null,
            device: window.matchMedia && window.matchMedia('(pointer: coarse)').matches ? 'touch' : 'pointer',
        });
    };
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        const keep = ({ name, value }) => {
            sample[name.toLowerCase()] = name === 'CLS' ? value.toFixed(3) : Math.round(value);
        };
        // reportAllChanges keeps LCP and CLS current, so whatever is sent is the latest value.
        getCLS(keep, true);
        getLCP(keep, true);
        getFID(keep);
        getFCP(keep);
        getTTFB(keep);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') send();
        });
        window.setTimeout(send, SEND_AFTER_MS);
    }).catch(() => {});
};

export default reportWebVitals;
